<template>
  <el-table-column
    prop="chain.name"
    label="Üzletlánc"
    show-overflow-tooltip
    min-width="120"
    sortable="custom"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.shop_chain_id"> {{ scope.row.chain.name }} </span>
      <el-tag type="danger" v-else size="small">Nincs üzletlánc</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'chain.name',
  };
</script>
